import { useState } from "react";
import { Box } from "@mui/material";
import { COLORS } from "components/v3/Theme/colors";
import { PATHS } from "constants/pathConstants";
import { useHistory, useLocation } from "react-router-dom";
import SurveyWrapper from "components/v3/sharedComponents/surveys/SurveyWrapper";
import SurveySummary from "components/v3/sharedComponents/surveys/SurveySummary";
import Mixpanel from "utils/mixpanel";
import { Model } from "survey-core";

const SURVEY_ID = "kit-request-questions";

const KitRequestSurvey = (): React.ReactElement => {
  const history = useHistory();
  const location = useLocation();
  const [showSummary, setShowSummary] = useState<boolean>(false);
  const [summarySurveyModel, setSummarySurveyModel] = useState<Model | null>(
    null
  );

  const handleOnConfirm = (): void => {
    if (!summarySurveyModel) return;

    Mixpanel.track("Survey kit-request-questions submitted");

    setShowSummary(false);
    summarySurveyModel.doComplete();
  };

  const handleOnCompleting = (
    surveyModel: Model,
    options: { allow: boolean }
  ): void => {
    if (!showSummary) {
      Mixpanel.track("Survey summary page shown for kit-request-questions");
      options.allow = false;
      setSummarySurveyModel(surveyModel);
      setShowSummary(true);
    }
  };

  const handleOnComplete = (): void => {
    history.push({
      pathname: PATHS.ORDER_KIT_SELECTION,
      search: location.search // Preserve the override token
    });
  };

  const handleOnSurveyInstantiated = (surveyModel: Model): void => {
    surveyModel.pagePrevText = "Back";
  };

  return (
    <>
      {showSummary && summarySurveyModel && (
        <Box
          sx={{
            backgroundColor: COLORS.WHITE,
            borderRadius: "16px",
            padding: {
              xs: "16px",
              md: "32px 64px 0 64px"
            }
          }}
        >
          <SurveySummary
            onBack={() => {
              Mixpanel.track("Survey summary exited with back button");
              setShowSummary(false);
            }}
            onSubmit={handleOnConfirm}
            surveyModel={summarySurveyModel}
          />
        </Box>
      )}
      <Box
        sx={
          showSummary
            ? {
                position: "absolute",
                left: "-10000px",
                top: "auto",
                width: "1px",
                height: "1px",
                overflow: "hidden"
              }
            : {}
        }
      >
        <SurveyWrapper
          containerClassName="kit-request-questions-container"
          onSurveyInstantiated={handleOnSurveyInstantiated}
          onComplete={handleOnComplete}
          onCompleting={handleOnCompleting}
          overrideNextButtonEnabled={true}
          surveyId={SURVEY_ID}
        />
      </Box>
    </>
  );
};

export default KitRequestSurvey;
